// @flow
import React from 'react';
import { Route } from 'react-router';

import Card from '../../Card';
import BackendSidebar from '../../BackendSidebar';
import BackendRoutesView from '../BackendRoutesView';
import BackendEventsView from '../BackendEventsView';
import BackendUsersView from '../BackendUsersView';
import BackendBusesView from '../BackendBusesView';
import BackendExitMethodsView from '../BackendExitMethodsView';
import BackendReportsView from '../BackendReportsView';
// import BackendSettingsView from '../BackendSettingsView';

import styles from './backendView.css';


const BackendView = () => (
  <div className={styles.viewport}>
    <BackendSidebar />
    <div className={styles.content}>
      <Card className={styles.contentCard} isRound clearMargins>
        <Route path="/admin/backend" exact component={BackendEventsView} />
        <Route path="/admin/backend/events" component={BackendEventsView} />
        <Route path="/admin/backend/routes" component={BackendRoutesView} />
        <Route path="/admin/backend/users" component={BackendUsersView} />
        <Route path="/admin/backend/buses" component={BackendBusesView} />
        <Route path="/admin/backend/exit-methods" component={BackendExitMethodsView} />
        <Route path="/admin/backend/reports" component={BackendReportsView} />
        {/* <Route path="/admin/backend/settings" component={BackendSettingsView} /> */}
      </Card>
    </div>
  </div>
);


export default BackendView;



// WEBPACK FOOTER //
// ./src/scripts/components/views/BackendView/index.jsx